import { UI_LinkButton } from 'ui/components/2-molecules/LinkButton/LinkButton';

type Props = Content.GridCell & {
	documentType: 'LinkButton';
	content: {
		properties: {
			title: string;
			link: {
				url: string;
				target: string;
			};
		};
	};
};

export const LinkButton = ({ content }: Props) => {
	const title = content?.properties?.title ?? '';
	const url = content?.properties?.link?.url ?? '';
	const target = content?.properties?.link?.target ?? '';

	if (!url) return null;
	return <UI_LinkButton url={url} title={title} target={target} />;
};
